import { RaiseText } from "../raise-components"
import React, { useState } from "react"
import { Button, Slider } from "@atos6/ui"
import { Card } from "../App.styles"
import { useStore } from "../containers"
import { SliderContainer } from "./Cells.styles"
import { openNotificationWithIcon } from "../components/Notification"
import { updateGatewayPlan } from "../gql/updateGatewayPlan"

// https://dev.to/angular/managing-key-value-constants-in-typescript-221g
const PLANS_KEYS = ["D2", "D15", "D30"] as const
const D2 = 1
const D15 = 15
const D30 = 30
type PLAN_KEY = typeof PLANS_KEYS[number]
const PLANS_VALUES = [D2, D15, D30] as const
type PLAN_VALUE = typeof PLANS_VALUES[number]

const PLANS: Record<PLAN_KEY, PLAN_VALUE> = {
  D2: D2,
  D15: D15,
  D30: D30,
}

const PLANS_BY_VALUE: Record<PLAN_VALUE, PLAN_KEY> = {
  [D2]: "D2",
  [D15]: "D15",
  [D30]: "D30",
}

const PLANS_DESCRIPTION = {
  [D2]: "1 dia",
  [D15]: "14 dias",
  [D30]: "30 dias",
}

export function AntecipationCell() {
  const { isAccountCreated, active, id, currentPlan, isDocumentOk } = useStore()
  const [name, setName] = useState(currentPlan as PLAN_KEY)
  const [isLoading, setIsLoading] = useState(false)
  const saveButton = name === "D2"
  const isButtonDisabled = saveButton || currentPlan === name
  // FIXME: mover para o store
  const isDisabled = !(active && isAccountCreated && isDocumentOk)

  // useEffect(() => {
  //   const currentGatewayPlanName =
  //     // @ts-ignore
  //     gatewayPlans.find(({ active }: any) => active)?.name || DEFAULT_PLAN
  //   setName(currentGatewayPlanName)
  // }, [gatewayPlans])

  const submit = async () => {
    setIsLoading(true)
    try {
      await updateGatewayPlan({ organizationId: id, name })
      openNotificationWithIcon(
        "success",
        "Prazo de recebimento alterado",
        `A partir de agora o prazo de recebimento é de ${
          PLANS_DESCRIPTION[PLANS[name]]
        }, as transações efetuadas a partir de agora estarão dentro deste prazo`,
      )
    } finally {
      setIsLoading(false)
    }
  }
  // FIXME: Extrair Slider e sua lógica para seu próprio component
  // FIXME: Utilizar
  return (
    <Card disabled={isDisabled}>
      <RaiseText fontSize="20px" fontWeight="600" textAlign="center" marginBottom="62px">
        Plano de recebimento para Cartão de Crédito
      </RaiseText>
      <RaiseText fontSize="16px" textAlign="center" fontWeight="600" marginBottom="38px">
        Receba em:
      </RaiseText>
      <SliderContainer>
        <Slider
          tooltipVisible={false}
          style={{ width: "70%" }}
          marks={PLANS_DESCRIPTION}
          min={D2}
          max={D30}
          value={PLANS[name]}
          defaultValue={D30}
          step={null}
          onChange={(value: number) => {
            setName(PLANS_BY_VALUE[value as PLAN_VALUE])
          }}
        />
      </SliderContainer>

      <RaiseText fontSize="14px" textAlign="center" marginTop="50px">
        Taxa de:
      </RaiseText>
      <RaiseText fontSize="20px" textAlign="center" marginBottom="32px">
        {PLANS[name] === D2 ? "4,69%" : PLANS[name] === D15 ? "3,89%" : "2,8% + R$0,10"}
      </RaiseText>
      {saveButton && (
        <RaiseText fontSize="12px" textAlign="center" marginBottom="32px">
          O plano de recebimento para “1 dia”, só é disponibilizado após análise, para isso é
          necessário clicar em “ Solicitar Ativação”. Enquanto estiver em análise você pode escolher
          as demais opções disponíveis
        </RaiseText>
      )}
      <div style={{ textAlign: "right" }}>
        {saveButton && (
          <Button onClick={() => console.log("link")} marginRight="10px">
            Solicitar ativação
          </Button>
        )}
        <Button onClick={submit} disabled={isButtonDisabled} type="primary" loading={isLoading}>
          Salvar
        </Button>
      </div>
    </Card>
  )
}
